import React from 'react';
import './ServiceList.css';
import Service from './Service';

function ServiceList(props) {
	const services = [
		'Commercial-Residential Real Estate Acquisitions',
		'Property Records Research',
		'Project Feasibility Studies & Code Analysis',
		'Commercial-Residential Land Use Entitlements Consultation, Strategy, & Representation',
		'Pre-Construction/Building Permit Expediting & Project Management',
		'Licensing & Permits [Alcohol – Entertainment – Dancing]',
		'Notification Packages & Radius Maps',
		'Public Hearing & Neighborhood Group Meeting Representation',
		'Code Enforcement & Orders to Comply'
	]

	return (
		<div className="c-service-list">
			<div className=" c-service-list__container u-doubleBaseInnerSpacing">
				<div className="c-service-list__header">Services We Offer</div>
				<div className="container c-service-list__service-container">
				{ services.map(function(service) {
						return <Service key={service} serviceName={service} />
					})
				}
				</div>
			</div>
		</div>
	)
}

export default ServiceList;


// WEBPACK FOOTER //
// ./src/components/ServiceList.js